import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { DailyUtilization } from '@/features/calendar/calendarUtilization';

export function UtilizationSummary({ day, unavailable = false }: { day: DailyUtilization; unavailable?: boolean }) {
  const { t, i18n } = useTranslation('calendar');
  const hours = (value: number) => value.toLocaleString(i18n.language, { maximumFractionDigits: 1 });
  const overloaded = day.occupiedHours > day.availableHours;
  const label = unavailable ? t('utilization.unavailable') : day.percent === null
    ? t('utilization.noCapacity') : `${String(day.percent)} %`;
  return (
    <Tooltip title={unavailable ? label : t('utilization.details', {
      occupied: hours(day.occupiedHours), available: hours(day.availableHours),
      unassigned: hours(day.unassignedHours),
    })}>
      <Box tabIndex={0} aria-label={`${t('utilization.title')} ${day.date}: ${label}`}
        sx={{ px: 0.5, height: '100%', overflow: 'hidden', bgcolor: 'action.hover',
          color: overloaded && !unavailable ? 'error.main' : 'text.primary', textAlign: 'center' }}>
        <Typography variant="caption" fontWeight={700} display="block" noWrap>{label}</Typography>
        {!unavailable && <Typography variant="caption" display="block" noWrap>
          {hours(day.occupiedHours)} / {hours(day.availableHours)} h
        </Typography>}
      </Box>
    </Tooltip>
  );
}
